<template>
  <div class="merge-name-info" :aria-hidden="alertVisible">
    <base-page-struct
      :footerConfig="{
        show: !isShowOrder,
        props: {
          value: '提交',
          disabled: !isAllowSubmit || !isAgree,
        },
        listener: {
          click: submit,
        },
      }"
      :showQa="!isShowOrder"
      :showTitle="!isShowOrder"
      v-on:toQa="handleGoQuestion"
    >
      <!-- <template #title>
        {{title}}
      </template> -->
      <!-- <template #desc>
        <div v-html="authState && authState.bankcard_collect_reason_in_risk"></div>
      </template> -->
      <template #agree>
        <cube-checkbox v-model="isAgree">
          <div class="base-page-desc">
            <div v-dompurify-html="authState && authState.bankcard_collect_reason_in_risk"></div>
          </div>
        </cube-checkbox>
      </template>
      <formter
        :options="{
          layout: 'classic'
        }"
        :model="model"
        :form.sync="form"
        :fields="fields"
      >
        <template #bank_card="scope">
          <bank-input
            v-bind="scope.field.props"
            v-on="scope.field.events"
            v-model="model.bank_card"
            :showBankName="showBankName"
            :bankName="bankName"
            type="text"
            @goCardList="goCardList"
          />
        </template>
        <template #sms_code="scope">
          <simple-verify-code
            v-bind="scope.field.props"
            v-on="scope.field.events"
            v-model="model.sms_code"
            :codeVisible.sync="isRetry"
            :time.sync="time"
            :isGrey="isGrey"
            @getCode="getCodeData"
          />
        </template>
      </formter>
      <myorders v-if="isShowOrder" @payover="payover"></myorders>
    </base-page-struct>
  </div>
</template>

<script>
import BasePageStruct from 'components/BasePageStruct/BasePageStruct.vue'
import Formter from 'components/Formter/Formter.vue'
import BankInput from 'components/BankInput/BankInput.vue'
import SimpleVerifyCode from 'components/SimpleVerifyCode/SimpleVerifyCode.vue'
import myorders from '../components/myorders'

import { validateId, validatePhone, validateBankCard } from 'common-js/util/validate'
import { name_auth_omega_summary } from 'common-js/omega'
import { rsaEncrypt } from 'common-js/util/tool'
import auth from 'common-js/api/auth'
import { setPageTitle, query } from '@didi/public-sdk'
import { mapGetters, mapMutations } from 'vuex'
import { fetchPost } from 'common-js/api/http'
import { CODE_TYPE } from 'common-js/util/const'
import { dbridge } from '@didi/driver-bridge'

import { sendOmega } from '../config/state'
import { urlObj } from '../config/url'
import { getSendSmsCode, getBankName, waitBridgeReady, getAuthState, initUnVerifiedRouter, showAlert, toast } from '../api'
import { SessionStorageService } from 'common-js/util/storage'

const nameStoreKey = 'merge_name'
const idStoreKey = 'merge_id'
const bankCardStoreKey = 'merge_bank_card'
const bankCellStoreKey = 'merge_bank_cell'

const VERIFY_REANME_TIP = {
  0: '',
  4: '抱歉，您的实名认证失败已达5次，请联系客服。',
  230: '抱歉，实名认证未通过',
  default: '认证失败',
}

export default {
  components: {
    BasePageStruct,
    Formter,
    BankInput,
    SimpleVerifyCode,
    myorders,
  },
  data() {
    return {
      model: {
        name: SessionStorageService.get(nameStoreKey) || '',
        id: SessionStorageService.get(idStoreKey) || '',
        bank_card: SessionStorageService.get(bankCardStoreKey) || '',
        bank_cell: SessionStorageService.get(bankCellStoreKey) || '',
        sms_code: '',
      },
      placeholder: {
        name: '请填写本人真实姓名',
        id: '请填写本人身份证号',
        bank_card: '请填写银行卡号码',
        bank_cell: '请填写银行卡预留手机号',
        sms_code: '验证码',
      },
      isRetry: true,
      isGrey: true,
      showBankName: false,
      isGuide: false,
      isShowOrder: false,
      form: null,
      time: 60,
      bankName: '',
      myorders: [],
      isAgree: false,
      type: 2,
      codeType: CODE_TYPE.SMS,
      verifyCodeType: CODE_TYPE.SMS,
      alertVisible: false,
    }
  },
  computed: {
    fields() {
      const that = this
      const inputProps = {
        clearable: {
          visible: true,
          blurHidden: true,
        }
      }
      return [
        {
          type: 'input',
          modelKey: 'name',
          label: '姓名',
          props: {
            ...inputProps,
            placeholder: that.placeholder.name,
          },
          rules: {
            required: true,
          },
          messages: {
            require: '必填'
          }
        },
        {
          type: 'input',
          modelKey: 'id',
          label: '身份证',
          props: {
            ...inputProps,
            placeholder: that.placeholder.id,
          },
          events: {
            blur: (e) => that.focusBlur(e, 'id')
          },
          rules: {
            required: true,
          },
          messages: {
            require: '必填'
          }
        },
        {
          type: 'input',
          modelKey: 'bank_card',
          label: '银行卡号',
          props: {
            ...inputProps,
            placeholder: that.placeholder.bank_card,
          },
          events: {
            input: that.dealCardIpt,
            blur: (e) => that.focusBlur(e, 'card'),
          },
          rules: {
            required: true,
          },
          messages: {
            require: '必填'
          }
        },
        {
          type: 'input',
          modelKey: 'bank_cell',
          label: '手机号',
          props: {
            ...inputProps,
            placeholder: that.placeholder.bank_cell,
          },
          events: {
            blur: (e) => that.focusBlur(e, 'cell'),
            input: that.cellInputHandle,
          },
          rules: {
            required: true,
          },
          messages: {
            require: '必填'
          }
        },
        {
          type: 'input',
          modelKey: 'sms_code',
          label: '验证码',
          props: {
            inputAttrs: {
              placeholder: that.placeholder.sms_code,
              maxlength: 6,
              type: 'tel',
            },
          },
          rules: {
            required: true,
          },
          messages: {
            require: '必填'
          }
        },
      ]
    },
    isAllowSubmit() {
      const visible = this.model.name &&
        validateId(this.model.id) &&
        this.model.bank_card && validateBankCard(this.model.bank_card.replace(/\s/g, '')) &&
        validatePhone(this.model.bank_cell) &&
        this.model.sms_code && this.model.sms_code.length === 6
      return visible
    },
    ...mapGetters([
      'verifyStatus',
      'cell_id',
      'roleId',
      'orders',
      'ticket',
      'env',
      'getReason',
      'identityCards',
      'docId',
      'authState',
      'unVerified',
    ]),
  },
  watch: {
    'model.name': {
      handler: function (val) {
        SessionStorageService.set(nameStoreKey, val)
      },
    },
    'model.id': {
      handler: function (val) {
        SessionStorageService.set(idStoreKey, val)
      },
    },
    'model.bank_card': {
      handler: function (val) {
        SessionStorageService.set(bankCardStoreKey, val)
      },
    },
    'model.bank_cell': {
      handler: function (val) {
        SessionStorageService.set(bankCellStoreKey, val)
      },
    }
  },
  methods: {
    ...mapMutations([
      'AUTH_STATE',
    ]),
    getCodeData(starTimer) {
      // 验证码倒计时，不可再次点击
      console.log('回调')
      if (!this.isRetry) {
        return
      }
      if (validatePhone(this.model.bank_cell)) {
        this.isRetry = false
        this.getSendSmsCodeData(starTimer)
        // this.timesHandle()
      }
    },
    getSendSmsCodeData(starTimer) {
      const param = {
        type: this.codeType,
        risk: JSON.stringify(this.$route.query),
        cell: '',
        cell_encrypted: this.model.bank_cell && rsaEncrypt(this.model.bank_cell.replace(/\s/g, '')),
      }
      getSendSmsCode(this, param, starTimer)
    },
    focusBlur (_e, str) {
      let idVal = ''
      let cardVal = ''
      let cellVal = ''
      if (str === 'id') {
        idVal = validateId(this.model.id)
      } else if (str === 'card') {
        cardVal = this.model.bank_card && validateBankCard(this.model.bank_card.replace(/\s/g, ''))
      } else if (str === 'cell') {
        cardVal = this.model.bank_cell && validatePhone(this.model.bank_cell.replace(/\s/g, ''))
      }
      if (cardVal || idVal || cellVal) {
        if (cardVal) {
          setTimeout(this.getBankNameData, 10)
        }
      } else if (!idVal || !cardVal || !cellVal) {
        this.showBankName = false
      }
    },
    dealCardIpt() {
      if (!this.model.bank_card) return
      let formatVal = this.model.bank_card.replace(/(\d{4})(?=\d)/g, '$1 ')
      this.model.bank_card = formatVal
      if (this.model.bank_card.length <= 0) {
        this.showBankName = false
      }
    },
    getBankNameData() {
      if (!this.model.bank_card) return
      const param = {
        ticket: this.ticket || auth.get('token'),
        bank_card: '',
        bank_card_encrypted: this.model.bank_card && rsaEncrypt(this.model.bank_card.replace(/\s/g, '')),
      }
      getBankName(this, param)
    },
    cellInputHandle() {
      if (validatePhone(this.model.bank_cell.replace(/\s/g, ''))) {
        this.isGrey = false
      } else {
        this.isGrey = true
      }
    },
    submit () {
      sendOmega(name_auth_omega_summary['trinity_id_ck'])
      if (!this.model.name || !validateId(this.model.id)) {
        toast(this, { txt: '请输入有效的姓名和身份证号码', type: 'warn', time: 1000 })
        return
      }
      const { type } = this.$route.query
      if (type && Number(type) === 2) {
        this.unbind()
      } else {
        toast(this, { txt: '认证中', time: 1000 })
        this.verifyRealname()
      }
    },
    async unbind () {
      toast(this, { txt: '解绑中', time: 1000 })
      const { id, name } = this.model
      const { cell_id } = this
      let parmas = {
        ticket: this.ticket || '',
        id_no: '',
        id_no_encrypted: id && rsaEncrypt(id),
        name,
        cell_id: '',
        cell_id_encrypted: cell_id.cell_id && rsaEncrypt(cell_id.cell_id)
      }
      const res = await fetchPost({
        url: urlObj.unbind,
        data: parmas
      })
      const { errno, errmsg, data } = res
      const omegaEventId = errno === 0
        ? 'pub_trinity_auth_unbound_suc_sw'
        : 'pub_trinity_auth_unbound_fail_sw'
      sendOmega(name_auth_omega_summary[omegaEventId], {
        errno
      })
      if (errno * 1 === 0) {
        toast(this, { txt: '解绑成功', type: 'correct', time: 1000 })
        this.goApp()
      } else if (errno * 1 === 5008) {
        if (this.env === 'passenger') {
          this.isShowOrder = true
          this.myorders = data.orders
        } else {
          this.alertVisible = true
          showAlert(this, {
            content: '抱歉，该账号下有未支付订单，请您在乘客端登录该账号完成支付后，方可解绑该账号。',
            onConfirm: () => {
              this.alertVisible = false
            }
          })
        }
      } else if (errno * 1 === 1203) {
        // this.$router.push({
        //   name: 'MesVerify',
        //   query: {
        //     type: 2
        //   }
        // })
        initUnVerifiedRouter(this)
      } else {
        this.alertVisible = true
        showAlert(this, {
          content: errmsg || '好像出错了',
          onConfirm: () => {
            this.alertVisible = false
          }
        })
      }
    },
    async verifyRealname () {
      const { ticket, roleId } = this
      const resTicket = ticket || auth.get('token')
      toast(this)
      let { biz, channel_id, back_url, from_page, isCloseWebview } = window.GlobalSet.query
      let _params = {
        ticket: resTicket,
        name: this.model.name,
        id_no: '',
        id_no_encrypted: this.model.id && rsaEncrypt(this.model.id),
        bank_cell_encrypted: this.model.bank_cell && rsaEncrypt(this.model.bank_cell.replace(/\s/g, '')),
        bank_card_encrypted: this.model.bank_card && rsaEncrypt(this.model.bank_card.replace(/\s/g, '')),
        sms_code: this.model.sms_code,
        type: this.verifyCodeType || CODE_TYPE.SMS,
        biz,
        doc_id: this.docId,
        channel_id
      }
      if (JSON.stringify(roleId) === '{}') {
        _params.role = 0
      } else if (roleId * 1 !== 999) {
        _params.role = roleId
      }
      const res = await fetchPost({
        url: urlObj.verifyRn,
        data: _params
      })
      const { errno, errmsg } = res
      let errTip = VERIFY_REANME_TIP[String(errno)] || errmsg || VERIFY_REANME_TIP.default
      const omegaEventId = errno === 0
        ? 'pub_trinity_auth_submit__suc_ck'
        : 'pub_trinity_auth_submit__fail_ck'
      sendOmega(name_auth_omega_summary[omegaEventId], {
        errno
      })
      if (errno * 1 === 0) {
        errTip = ''
        toast(this, { txt: '实名认证成功', type: 'correct', time: 1000 })
        if (back_url) {
          location.replace(decodeURIComponent(back_url))
        } else if (from_page === 'conflict') {
          return this.conflictNext()
        } else if (Number(isCloseWebview) === 1) {
          this.closeWebView()
        } else {
          this.goApp()
        }
      }
      // 需要进行人脸识别 不需要进行错误信息弹窗提示
      if (errTip && errno !== 1) {
        this.alertVisible = true
        showAlert(this, {
          content: errTip,
          onConfirm: () => {
            this.alertVisible = false
          }
        })
      }
    },
    conflictNext() {
      waitBridgeReady().then(() => {
        toast(this, {
          txt: '认证成功，页面关闭中...',
          type: 'warn',
          time: 1000,
          onTimeout: () => {
            window.DidiJSBridge.callHandler('closeWebView', {}, () => {})
          }
        })
      })
    },
    // 进入首页
    goApp() {
      this.$router.replace({
        name: 'App',
        params: {
          needFresh: true
        }
      })
    },
    // 关闭端Webview
    closeWebView() {
      if (this.env === 'passenger') {
        window.D.bridge.call('closePage', {}, () => {})
      } else if (this.env === 'driver') {
        dbridge.closePage()
      }
    },
    handleGoQuestion() {
      sendOmega(name_auth_omega_summary['pub_identity_faq_ck'], this.omegaParams)
      this.$router.push({
        path: '/Faq',
        query: {
          ...window.GlobalSet.query
        }
      })
    },
    goCardList() {
      window.location.href = `${urlObj.bankList}${query.stringifyQuery(window.GlobalSet.query)}`
    },
  },
  mounted() {
    sendOmega(name_auth_omega_summary['pub_trinity_id_sw'])
    setPageTitle({
      title: '统一实名认证'
    })
    if (this.model.bank_card) {
      this.getBankNameData()
    }
    this.cellInputHandle()
    getAuthState(this, { bankcard_auth: true })
  }
}
</script>

<style lang="scss">
@import '~common-css/func.scss';

.cube-checkbox-label a {
  position: relative;
  z-index: 1;
}
.merge-name-info {
  height: 100%;
  padding: 0 px2rem(32);
}
</style>
